export class Invites {
    email:string;
    isAttending:number=-1;
    reason:string=null;
}


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/invites.ts